import React from "react";
import { ACTIONS } from "../state/contexts/quizState";
import { useQuiz } from "../services/hooks/useQuiz";

export default React.memo(function QuizQ6({ isActive }) {
  const { setAnswer, quizResponses } = useQuiz();

  const { makeupLevel } = quizResponses;

  const onAnswer = (answer) => {
    setAnswer(ACTIONS.SET_MAKEUP_LEVEL, {
      makeupLevel: answer,
    });
  };

  const options = [
    {
      title: "Beginner",
      text: `I'm just getting into makeup. Until now, I haven't used much
      makeup.`,
    },
    {
      title: "Intermediate",
      text: `I use and buy makeup regularly. I usually have makeup on whenever
      I leave the house.`,
    },
    {
      title: "Expert",
      text: `I slay every look - Every single one! I can also apply makeup
      comfortably on others.`,
    },
  ];

  const listItems = options.map(({ title, text }) => (
    <div
      key={title}
      className="quiz-radio-option"
      onClick={() => onAnswer(title)}
    >
      <div className="custom-control custom-radio float-left">
        <input
          type="radio"
          id={title}
          name="makeupLevel"
          value={title}
          className="custom-control-input"
          checked={makeupLevel === title}
          onChange={(e) => {
            onAnswer(e.target.value);
          }}
        />
        <label className="custom-control-label" htmlFor={title}></label>
      </div>
      <div className="ml-8 quiz-radio-content">
        <div className="font-size-h6">{title}</div>
        <p className="text-muted">{text}</p>
      </div>
    </div>
  ));

  if (!isActive) {
    return null;
  }

  return (
    <React.Fragment>
      <h4 className="mb-8">How comfortable are you with makeup?</h4>

      <div className="quiz-radio-options">{listItems}</div>
    </React.Fragment>
  );
});
